import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import Home from "./pages/home/Home";
import { MantineProvider } from "@mantine/core";
import Footer from "./components/footer/Footer";
import About from "./pages/about/About";
import Register from "./pages/registration/Register";
import Login from "./pages/login/Login";
import Navbar from "./components/navbar/Navbar";
import AuthFooter from "./components/authFooter/AuthFooter";
import Track from "./pages/track/Track";
import Admin from "./admin/Admin";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./theme";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import { userInputs, productInputs } from "./formSource";
import { Provider } from "react-redux";
import store from "./app/store";
import PartnerRegister from "./pages/warehouseAuth/register/PartnerRegister";
import WareDash from "./WarehouseManagement/WareDash";
import { ChakraProvider } from "@chakra-ui/react";
import Products from "./pages/ProductPage/addNewProduct/Products";
import WarehouseManifest from "./pages/ProductPage/WarehouseManifest/WarehouseManifest";
import AddShip from "./pages/shipments/AddShip/AddShip";
import Label from "./pages/shipments/ShippingLabel/Label";
import ViewShipment from "./pages/shipments/ViewShip/ViewShipment";
import ProductEmail from "./pages/ProductPage/ViewByEmail/ProductEmail";
import AllCustomerAccountsInterface from "./components/MANAGEMENT/AllCustomerAccountsInterface/AllCustomerAccountsInterface";
import CustRegister from "./pages/customer/register/CustRegister";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import UnAuthorized from "./components/unAuthorized/UnAuthorized";
import RegisterCourier from "./pages/courier/register/RegisterCourier";
import ProfilePage from "./pages/warehouse/profilePage/ProfilePage";
// import Customer from "./pages/customer/customerDash/Customer";
import CustomerStatusStream from "./pages/customer/customerDash/CustomerStatusStream";

import Courier from "./pages/courier/courierDash/Courier";
import Settings from "./components/Settings/Settings";
import Delivery from "./components/delivery/Delivery";
import InvoiceUpload from "./components/customers/InvoiceUpload";
import OrderDetails from "./components/OrderDetails/OrderDetails";
import CustSettings from "./components/customers/Settings/Settings";
import CustProfile from "./components/customers/Profile/Profile";
import AdminOrders from "./components/MANAGEMENT/orders/orders";
import AdminProducts from "./components/MANAGEMENT/products/products";
import ViewAllProductsTable from "./components/MANAGEMENT/AdminViewForAllProductsFromCustomers/ViewAllProductsTable";
import AdminProfile from "./components/MANAGEMENT/profile/profile";
// import Statistics from "./components/MANAGEMENT/stats/stats";
import AdminSettings from "./components/MANAGEMENT/settings/settings";
import PasswordReset from "./components/PasswordReset/PasswordReset";
import PasswordResetEmail from "./components/PasswordReset/PasswordResetEmail";
import Manifest from "./pages/shipments/ShippingManifest/Manifest";
import VerifyEmail from "./components/verifyemail/VerifyEmail";
import CheckEmail from "./pages/customer/register/checkEmail";
import "./firebase-config";
import TableIteration from "./pages/customer/customerDash/TableIteration.jsx";
import { ThemeProvider as TailwindThemeProvider } from "@material-tailwind/react";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>
// );

// const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
// Redirect component
const RedirectToExternal = () => {
  window.location.href = "https://www.junelogistics.com";
  return null;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectToExternal />,
  },
  {
    path: "about",
    element: (
      <div>
        <Navbar />
        <About />
      </div>
    ),
  },
  {
    path: "register",
    element: (
      <div>
        <Register />
        <AuthFooter />
      </div>
    ),
  },
  {
    path: "verifyemail",
    element: (
      <div>
        <VerifyEmail />
      </div>
    ),
  },
  {
    path: "login",
    element: (
      <div>
        <Login />
      </div>
    ),
  },
  {
    path: "password/reset/email",
    element: (
      <div>
        <PasswordResetEmail />
      </div>
    ),
  },
  {
    path: "resetpassword/",
    element: (
      <div>
        <PasswordReset />
      </div>
    ),
  },
  {
    path: "warehouse/register",
    element: (
      <div>
        <PartnerRegister />
        <AuthFooter />
      </div>
    ),
  },
  {
    path: "warehouse/dash",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
          <WareDash />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "warehouse/dash/products",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
          <Products />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "warehouse/dash/products/viewProducts",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <WarehouseManifest />
      </ProtectedRoute>
    ),
  },
  {
    path: "warehouse/dash/products/viewProducts/email",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <ProductEmail />
      </ProtectedRoute>
    ),
  },
  {
    path: "warehouse/dash/shipments",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <AddShip />
      </ProtectedRoute>
    ),
  },
  {
    path: "warehouse/dash/shipments/label",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <Label />
      </ProtectedRoute>
    ),
  },
  {
    path: "warehouse/dash/shipments/manifest",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <Manifest />
      </ProtectedRoute>
    ),
  },
  {
    path: "warehouse/dash/shipments/view",
    element: (
      <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
        <ViewShipment />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "warehouse/dash/customers",
  //   element: (
  //     <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
  //       <ViewCust />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: "warehouse/dash/settings",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["WAREHOUSE_CLERK"]}>
          <Settings />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "track",
    element: (
      <div>
        <Navbar />
        <Track />
        <Footer />
      </div>
    ),
  },
  {
    path: "admin",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <Admin />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/users",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <AllCustomerAccountsInterface />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/orders",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <AdminOrders />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/profile",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <AdminProfile />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/packages",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <AdminProducts />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/all-customer-packages",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <ViewAllProductsTable />
        </ProtectedRoute>
      </div>
    ),
  },
  // {
  //   path: "admin/stats",
  //   element: (
  //     <div>
  //       <ProtectedRoute allowedRoles={["ADMIN"]}>
  //         <Statistics />
  //       </ProtectedRoute>
  //     </div>
  //   ),
  // },
  {
    path: "admin/settings",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <AdminSettings />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/users/:id",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <Single />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/users/new",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <New inputs={userInputs} title="Add New User" />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "admin/users/products/new",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["ADMIN"]}>
          <New inputs={productInputs} title="Add New Product" />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "customer/register",
    element: (
      <div>
        <CustRegister />
      </div>
    ),
  },
  {
    path: "customer/register/checkEmail",
    element: (
      <div>
        <CheckEmail />
      </div>
    ),
  },
  {
    path: "courier/register",
    element: (
      <div>
        <RegisterCourier />
      </div>
    ),
  },
  {
    path: "/unauthorized",
    element: (
      <div>
        <UnAuthorized />
      </div>
    ),
  },
  {
    path: "/user/warehouse/profile",
    element: (
      <div>
        <ProfilePage />
      </div>
    ),
  },
  {
    path: "customer/dash",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <CustomerStatusStream />
        </ProtectedRoute>
      </div>
    ),
  },
  // {
  //   path: "customer/dash/table",
  //   element: (
  //     <div>
  //       <ProtectedRoute allowedRoles={["CUSTOMER"]}>
  //         <TableIteration />
  //       </ProtectedRoute>
  //     </div>
  //   ),
  // },
  {
    path: "customer/dash/deliveries",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <Delivery />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "customer/dash/orders",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <OrderDetails />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "customer/dash/invoices",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <InvoiceUpload />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "customer/dash/settings",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <CustSettings />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "customer/dash/profile",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["CUSTOMER"]}>
          <CustProfile />
        </ProtectedRoute>
      </div>
    ),
  },
  {
    path: "courier/dash",
    element: (
      <div>
        <ProtectedRoute allowedRoles={["COURIER"]}>
          <Courier />
        </ProtectedRoute>
      </div>
    ),
  },
]);



createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ChakraProvider>
      <ThemeProvider theme={theme}>
        <TailwindThemeProvider>
        <RouterProvider router={router} />
        </TailwindThemeProvider>
      </ThemeProvider>
    </ChakraProvider>
  </Provider>
);
